export default "__VITE_PUBLIC_ASSET__54ce0f0c__"